import React, { useEffect, useRef } from "react";
import { FaImage } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import "./SalesPageNew.css";

const S3_VIDEO = 'https://openaccessimages.s3.eu-west-2.amazonaws.com/sales-page-assets';
const featureDefs = [
   { tagKey: "designTag", titleKey: "designTitle", descKey: "designDesc", video: `${S3_VIDEO}/design-agent.mp4` },
   { tagKey: "copyTag", titleKey: "copyTitle", descKey: "copyDesc", video: `${S3_VIDEO}/copywriting-agent.mp4` },
   { tagKey: "salesTag", titleKey: "salesTitle", descKey: "salesDesc", video: `${S3_VIDEO}/sales-agent.mp4` },
   { tagKey: "metaTag", titleKey: "metaTitle", descKey: "metaDesc", video: `${S3_VIDEO}/meta-agent.mp4` },
];

function AutoPlayVideo({ src }) {
   const ref = useRef(null);
   useEffect(() => {
      const el = ref.current;
      if (!el) return;
      const io = new IntersectionObserver(
         entries => {
            entries.forEach(e => {
               if (e.isIntersecting) el.play().catch(() => {});
               else el.pause();
            });
         },
         { threshold: 0.4 },
      );
      io.observe(el);
      return () => io.disconnect();
   }, []);

   return (
      <video ref={ref} src={src} style={{ width: '100%', height: '100%', objectFit: 'cover' }}
         muted loop playsInline preload="metadata" />
   );
}

export default function AgentFeatures({ windowWidth }) {
   const { t } = useTranslation();
   const isMobile = windowWidth < 768;
   return (
      <section style={{ maxWidth: 1152, margin: '0 auto', padding: '96px 24px' }}>
         <div style={{
            display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 32,
         }}>
            {featureDefs.map(f => (
               <div key={f.tagKey} className="sp-surface-card sp-card-lift" style={{
                  display: 'flex', flexDirection: 'column', borderRadius: 24, padding: 32,
               }}>
                  <p style={{ fontSize: 16, fontWeight: 600, color: 'var(--sp-brand)', textTransform: 'none' }}>{t(`salesPageNew.agentFeatures.${f.tagKey}`)}</p>
                  <h3 style={{ marginTop: 12, fontSize: 32, color: 'var(--sp-ink)', fontWeight: 600, letterSpacing: '-0.02em' }}>
                     {t(`salesPageNew.agentFeatures.${f.titleKey}`)}
                  </h3>
                  <p style={{ marginTop: 12, color: 'var(--sp-text-soft)', fontSize: 17, lineHeight: 1.7, textTransform: 'none', fontWeight: 400 }}>
                     {t(`salesPageNew.agentFeatures.${f.descKey}`)}
                  </p>
                  <div style={{ marginTop: 'auto', paddingTop: 24 }}>
                     <div style={{
                        aspectRatio: '16/9', display: 'flex', alignItems: 'center', justifyContent: 'center',
                        overflow: 'hidden', borderRadius: 16, background: 'var(--sp-bg-soft)', color: 'var(--sp-text-muted)',
                     }}>
                        {f.video ? (
                           <AutoPlayVideo src={f.video} />
                        ) : (
                           <FaImage style={{ width: 32, height: 32 }} />
                        )}
                     </div>
                  </div>
               </div>
            ))}
         </div>
      </section>
   );
}
